var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 191,
    viewBox: "0 0 390 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.9521L22.3611 68.7553C44.7222 77.6585 89.4445 95.265 134.167 97.7659C178.889 100.267 223.611 87.6622 268.333 72.1566C313.056 56.6509 357.778 38.2441 402.5 22.4384C447.222 6.63258 491.944 -6.77233 536.667 3.73151C581.389 14.2353 626.111 48.648 670.833 67.1547C715.556 85.6615 760.278 88.2624 782.639 89.663L805 90.9634V191H782.639C760.278 191 715.556 191 670.833 191C626.111 191 581.389 191 536.667 191C491.944 191 447.222 191 402.5 191C357.778 191 313.056 191 268.333 191C223.611 191 178.889 191 134.167 191C89.4445 191 44.7222 191 22.3611 191H0V59.9521Z",
    fill: "url(#paint0_linear_36_166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_166",
    x1: 402.5,
    y1: 0,
    x2: 402.5,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD85",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.66ba3368e9caa8366b3c39a3274119e2.svg";
export { ForwardRef as ReactComponent };